export const CATEGORY_DETAILS = 'category';
export const INFORMATION_ABOUT_THE_RADIO_COM_EQUIPMENT_SETUP = 'information-about-the-radio-com-equipment-setup';
export const OTHER_DETAILS = 'other-details';
export const STATION_DETAILS = 'station-details';
export const SUPPORTING_DOCUMENTS = 'supporting-documents';

export const AMEND_LRS_LICENCE = [
    {
        sectionID: CATEGORY_DETAILS,
        sectionName: '',
        fieldList: [
            {
                id: 'amend-table',
                label: ' ',
                type: 'table',
                subFields: [
                    {
                        id: 'type',
                        header: 'I want to amend',
                        type: 'text'
                    }
                ],
                span: 12
            },
            {
                id: 'licence-category',
                label: 'Licence Category',
                type: 'text'
            }
        ]
    },
    {
        sectionID: INFORMATION_ABOUT_THE_RADIO_COM_EQUIPMENT_SETUP,
        sectionName: 'Information About the Radio-Com Equipment Setup',
        fieldList: [
            {
                id: 'purpose-of-communication',
                label: 'Purpose of Communication',
                type: 'text',
                span: 12
            },
            {
                id: 'is-this-fixed-station-located-at-the-above-building-either-owned-or-occupied-by-you',
                label: 'Is this fixed station(s) located at the above building(s) either owned or occupied by you?',
                type: 'text',
                span: 12
            },
            {
                id: 'is-the-above-building-separated-by-public-road-canal-etc',
                label: 'Is the above building(s) separated by public road(s), canal(s), etc.?',
                type: 'text',
                span: 12
            },
            {
                id: 'building-within-the-same-premises',
                label: 'Building within the same premises?',
                type: 'text',
                span: 12
            },
            {
                id: 'intra-corporate-communication',
                label: 'Intra-corporate communication',
                type: 'text',
                span: 12
            },
            {
                id: 'does-the-mobile-station-operate-within-the-same-premises-or-in-confined-areas-ie-no-public-road-canal-etc-in-the-area-of-operation',
                label: `Does the mobile station(s) operate within the same premises or in confined areas, 
                i.e. no public road(s), canal(s), etc. in the area of operation?`,
                type: 'text',
                span: 12
            },
            {
                id: 'equipment-compliance-with-imda-ts-srd',
                label: 'Equipment compliance with IMDA TS SRD',
                type: 'text',
                span: 12
            }
        ]
    },
    {
        sectionID: OTHER_DETAILS,
        sectionName: 'Other Details',
        fieldList: [
            {
                id: 'proposed-use-of-system',
                label: 'Proposed Use of System',
                type: 'text',
                span: 12
            },
            {
                id: 'remarks',
                label: 'Remarks',
                type: 'text',
                span: 12
            }
        ]
    },
    {
        sectionID: STATION_DETAILS,
        sectionName: '',
        fieldList: [
            {
                id: 'station-tabs',
                label: '',
                type: 'tab',
                span: 12,
                tabs: [
                    {
                        id: '1',
                        label: 'Fixed Station Details',
                        type: 'subTab',
                        subTabs: [
                            {
                                id: '1',
                                label: 'Station 1',
                                content: [
                                    {
                                        id: 'area-of-operation',
                                        label: 'Area of Operation',
                                        type: 'text'
                                    },
                                    {
                                        id: 'call-sign',
                                        label: 'Call Sign',
                                        type: 'text'
                                    },
                                    {
                                        id: 'location-of-station',
                                        label: 'Location of Station',
                                        type: 'text'
                                    },
                                    {
                                        id: 'station-name',
                                        label: 'Station Name',
                                        type: 'text'
                                    },
                                    {
                                        id: 'address',
                                        label: 'Address',
                                        type: 'subsection'
                                    },
                                    {
                                        id: 'building-name',
                                        label: 'Building Name',
                                        type: 'text'
                                    },
                                    {
                                        id: 'postal-code',
                                        label: 'Postal Code',
                                        type: 'text'
                                    },
                                    {
                                        id: 'street-name',
                                        label: 'Street Name',
                                        type: 'text'
                                    },
                                    {
                                        id: 'block-house-no',
                                        label: 'Block/House No.',
                                        type: 'text'
                                    },
                                    {
                                        id: 'unit',
                                        label: 'Unit',
                                        type: 'text'
                                    },
                                    {
                                        id: 'floor-level',
                                        label: 'Floor/Level',
                                        type: 'text'
                                    },
                                    {
                                        id: 'latitude',
                                        label: 'Latitude',
                                        type: 'subsection'
                                    },
                                    {
                                        id: 'latitude-degrees',
                                        label: 'Latitude Degrees',
                                        type: 'text'
                                    },
                                    {
                                        id: 'latitude-minutes',
                                        label: 'Latitude Minutes',
                                        type: 'text'
                                    },
                                    {
                                        id: 'latitude-seconds',
                                        label: 'Latitude Seconds',
                                        type: 'text'
                                    },
                                    {
                                        id: 'longitude',
                                        label: 'Longitude',
                                        type: 'subsection'
                                    },
                                    {
                                        id: 'longitude-degrees',
                                        label: 'Longitude Degrees',
                                        type: 'text'
                                    },
                                    {
                                        id: 'longitude-minutes',
                                        label: 'Longitude Minutes',
                                        type: 'text'
                                    },
                                    {
                                        id: 'longitude-seconds',
                                        label: 'Longitude Seconds',
                                        type: 'text'
                                    },
                                    {
                                        id: '',
                                        label: '',
                                        type: 'text'
                                    },
                                    {
                                        id: 'building-height-m',
                                        label: 'Building Height (m)',
                                        type: 'text'
                                    },
                                    {
                                        id: 'antenna-effective-height-m-above-ground-level-station',
                                        label: 'Antenna Effective Height (m) (above ground level)',
                                        type: 'text'
                                    },
                                    {
                                        id: 'elevation-angle-station',
                                        label: 'Elevation Angle',
                                        type: 'text'
                                    },
                                    {
                                        id: 'radius-of-operation-km',
                                        label: 'Radius of Operation (km)',
                                        type: 'text'
                                    },
                                    {
                                        id: 'vendor-information',
                                        label: 'Vendor Information',
                                        type: 'subsection'
                                    },
                                    {
                                        id: 'vendor-name',
                                        label: 'Vendor Name',
                                        type: 'text'
                                    },
                                    {
                                        id: 'vendor-licence-number',
                                        label: 'Vendor Licence Number',
                                        type: 'text'
                                    },
                                    {
                                        id: 'contact-person',
                                        label: 'Contact Person',
                                        type: 'text'
                                    },
                                    {
                                        id: 'contact-number',
                                        label: 'Contact Number',
                                        type: 'text'
                                    },
                                    {
                                        id: 'do-you-have-an-address-for-the-vendor',
                                        label: 'Do you have an address for the vendor',
                                        type: 'text'
                                    },
                                    {
                                        id: 'vendor-address',
                                        label: 'Vendor Address',
                                        type: 'subsection'
                                    },
                                    {
                                        id: 'vendor-building-name',
                                        label: 'Building Name',
                                        type: 'text'
                                    },
                                    {
                                        id: 'vendor-postal-code',
                                        label: 'Postal Code',
                                        type: 'text'
                                    },
                                    {
                                        id: 'vendor-street-name',
                                        label: 'Street Name',
                                        type: 'text'
                                    },
                                    {
                                        id: 'vendor-block-house-no',
                                        label: 'Block/House No.',
                                        type: 'text'
                                    },
                                    {
                                        id: 'vendor-unit',
                                        label: 'Unit',
                                        type: 'text'
                                    },
                                    {
                                        id: 'vendor-floor-level',
                                        label: 'Floor/Level',
                                        type: 'text'
                                    },
                                    {
                                        id: 'radio-equipment-information',
                                        label: 'Radio Equipment Information',
                                        type: 'subsection'
                                    },
                                    {
                                        id: 'manufacturer-transmitter',
                                        label: 'Manufacturer (Transmitter)',
                                        type: 'text'
                                    },
                                    {
                                        id: 'manufacturer-receiver',
                                        label: 'Manufacturer (Receiver)',
                                        type: 'text'
                                    },
                                    {
                                        id: 'model-transmitter',
                                        label: 'Model (Transmitter)',
                                        type: 'text'
                                    },
                                    {
                                        id: 'model-receiver',
                                        label: 'Model (Receiver)',
                                        type: 'text'
                                    },
                                    {
                                        id: 'output-power-w-transmitter',
                                        label: 'Output Power (W) (Transmitter)',
                                        type: 'text'
                                    },
                                    {
                                        id: 'tuned-frequency-mhz',
                                        label: 'Tuned Frequency (MHz)',
                                        type: 'text'
                                    },
                                    {
                                        id: 'antenna-information',
                                        label: 'Antenna Information',
                                        type: 'subsection'
                                    },
                                    {
                                        id: 'antenna-manufacturer',
                                        label: 'Manufacturer',
                                        type: 'text'
                                    },
                                    {
                                        id: 'polarization',
                                        label: 'Polarization',
                                        type: 'text'
                                    },
                                    {
                                        id: 'antenna-effective-height-m-above-ground-level',
                                        label: 'Antenna Effective Height (m) (above ground level)',
                                        type: 'text'
                                    },
                                    {
                                        id: 'elevation-angle',
                                        label: 'Elevation Angle',
                                        type: 'text'
                                    },
                                    {
                                        id: 'gain-db',
                                        label: 'Gain (dB)',
                                        type: 'text'
                                    },
                                    {
                                        id: 'antenna-tuned-frequency-mhz',
                                        label: 'Tuned Frequency (MHz)',
                                        type: 'text'
                                    },
                                    {
                                        id: 'frequency-and-emission-class-information',
                                        label: 'Frequency and Emission Class Information',
                                        type: 'subsection',
                                        fieldlist: [
                                            {
                                                id: 'frequency-and-emission-class-information-table',
                                                label: '',
                                                type: 'table',
                                                subFields: [
                                                    {
                                                        id: 'assigned-frequency-mhz-from-tx',
                                                        header: 'Assigned Frequency (MHz) - From (Tx)',
                                                        type: 'text'
                                                    },
                                                    {
                                                        id: 'assigned-frequency-mhz-to-tx',
                                                        header: 'Assigned Frequency (MHz) - To (Tx)',
                                                        type: 'text'
                                                    },
                                                    {
                                                        id: 'assigned-frequency-mhz-from-rx',
                                                        header: 'Assigned Frequency (MHz) - From (Rx)',
                                                        type: 'text'
                                                    },
                                                    {
                                                        id: 'assigned-frequency-mhz-to-rx',
                                                        header: 'Assigned Frequency(MHz) - To (Rx)',
                                                        type: 'text'
                                                    },
                                                    {
                                                        id: 'assigned-bandwidth-khz-tx',
                                                        header: 'Assigned Bandwidth (kHz) (Tx)',
                                                        type: 'text'
                                                    },
                                                    {
                                                        id: 'assigned-bandwidth-khz-rx',
                                                        header: 'Assigned Bandwidth (kHz) (Rx)',
                                                        type: 'text'
                                                    },
                                                    {
                                                        id: 'start-time',
                                                        header: 'Start Time',
                                                        type: 'text'
                                                    },
                                                    {
                                                        id: 'stop-time',
                                                        header: 'Stop Time',
                                                        type: 'text'
                                                    }
                                                ]
                                            },
                                            {
                                                id: 'frequency-and-emission-class-information-accordion',
                                                label: '',
                                                type: 'accordion',
                                                subFields: [
                                                    {
                                                        id: 'emission-class',
                                                        label: 'Emission Class',
                                                        type: 'text'
                                                    },
                                                    {
                                                        id: 'output-power-req',
                                                        label: 'Output Power Required (Werp)',
                                                        type: 'text'
                                                    },
                                                    {
                                                        id: 'assigned-transmit-frequency-details',
                                                        label: 'Assigned Transmit Frequency details',
                                                        type: 'text'
                                                    },
                                                    {
                                                        id: '',
                                                        label: '',
                                                        type: 'text'
                                                    },
                                                    {
                                                        id: 'frequency-entry-tx',
                                                        label: 'Frequency Entry',
                                                        type: 'text'
                                                    },
                                                    {
                                                        id: 'power',
                                                        label: 'Power (≤)',
                                                        type: 'text'
                                                    },
                                                    {
                                                        id: 'power-unit',
                                                        label: 'Power Unit',
                                                        type: 'text'
                                                    },
                                                    {
                                                        id: '',
                                                        label: '',
                                                        type: 'text'
                                                    },
                                                    {
                                                        id: 'assigned-receive-frequency-details',
                                                        label: 'Assigned Receive Frequency details',
                                                        type: 'text'
                                                    },
                                                    {
                                                        id: '',
                                                        label: '',
                                                        type: 'text'
                                                    },
                                                    {
                                                        id: 'frequency-entry-rx',
                                                        label: 'Frequency Entry',
                                                        type: 'text'
                                                    }
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        id: '2',
                        label: 'Mobile Station Details',
                        type: 'subTab',
                        subTabs: [
                            {
                                id: '1',
                                label: 'Station 1',
                                content: [
                                    {
                                        id: 'area-of-operation',
                                        label: 'Area of Operation',
                                        type: 'text'
                                    },
                                    {
                                        id: 'call-sign',
                                        label: 'Call Sign',
                                        type: 'text'
                                    },
                                    {
                                        id: 'station-name',
                                        label: 'Station Name',
                                        type: 'text'
                                    },
                                    {
                                        id: 'address',
                                        label: 'Address',
                                        type: 'subsection'
                                    },
                                    {
                                        id: 'building-name',
                                        label: 'Building Name',
                                        type: 'text'
                                    },
                                    {
                                        id: 'postal-code',
                                        label: 'Postal Code',
                                        type: 'text'
                                    },
                                    {
                                        id: 'street-name',
                                        label: 'Street Name',
                                        type: 'text'
                                    },
                                    {
                                        id: 'block-house-no',
                                        label: 'Block/House No.',
                                        type: 'text'
                                    },
                                    {
                                        id: 'unit',
                                        label: 'Unit',
                                        type: 'text'
                                    },
                                    {
                                        id: 'floor-level',
                                        label: 'Floor/Level',
                                        type: 'text'
                                    },
                                    {
                                        id: 'latitude',
                                        label: 'Latitude',
                                        type: 'subsection'
                                    },
                                    {
                                        id: 'latitude-degrees',
                                        label: 'Latitude Degrees',
                                        type: 'text'
                                    },
                                    {
                                        id: 'latitude-minutes',
                                        label: 'Latitude Minutes',
                                        type: 'text'
                                    },
                                    {
                                        id: 'latitude-seconds',
                                        label: 'Latitude Seconds',
                                        type: 'text'
                                    },
                                    {
                                        id: 'longitude',
                                        label: 'Longitude',
                                        type: 'subsection'
                                    },
                                    {
                                        id: 'longitude-degrees',
                                        label: 'Longitude Degrees',
                                        type: 'text'
                                    },
                                    {
                                        id: 'longitude-minutes',
                                        label: 'Longitude Minutes',
                                        type: 'text'
                                    },
                                    {
                                        id: 'longitude-seconds',
                                        label: 'Longitude Seconds',
                                        type: 'text'
                                    },
                                    {
                                        id: '',
                                        label: '',
                                        type: 'text'
                                    },
                                    {
                                        id: 'area-of-operation-line-1',
                                        label: 'Area of Operation - (Line 1)',
                                        type: 'text'
                                    },
                                    {
                                        id: 'area-of-operation-line-2',
                                        label: 'Area of Operation - (Line 2)',
                                        type: 'text'
                                    },
                                    {
                                        id: 'area-of-operation-line-3',
                                        label: 'Area of Operation - (Line 3)',
                                        type: 'text'
                                    },
                                    {
                                        id: 'no-of-mobiles',
                                        label: 'No. of Mobiles',
                                        type: 'text'
                                    },
                                    {
                                        id: 'mobile-communication-with',
                                        label: 'Mobile Communication With',
                                        type: 'text'
                                    },
                                    {
                                        id: 'coverage-information',
                                        label: 'Coverage Information',
                                        type: 'text'
                                    },
                                    {
                                        id: 'radio-equipment-information',
                                        label: 'Radio Equipment Information',
                                        type: 'subsection'
                                    },
                                    {
                                        id: 'manufacturer-transmitter',
                                        label: 'Manufacturer (Transmitter)',
                                        type: 'text'
                                    },
                                    {
                                        id: 'manufacturer-receiver',
                                        label: 'Manufacturer (Receiver)',
                                        type: 'text'
                                    },
                                    {
                                        id: 'model-transmitter',
                                        label: 'Model (Transmitter)',
                                        type: 'text'
                                    },
                                    {
                                        id: 'model-receiver',
                                        label: 'Model (Receiver)',
                                        type: 'text'
                                    },
                                    {
                                        id: 'output-power-w-transmitter',
                                        label: 'Output Power (W) (Transmitter)',
                                        type: 'text'
                                    },
                                    {
                                        id: 'mobile-station-frequency-info',
                                        label: 'Mobile Station - Frequency Info',
                                        type: 'subsection',
                                        fieldlist: [
                                            {
                                                id: 'mobile-station-frequency-info-table',
                                                label: '',
                                                type: 'table',
                                                subFields: [
                                                    {
                                                        id: 'assigned-frequency-mhz-from-tx',
                                                        header: 'Assigned Frequency (MHz) - From (Tx)',
                                                        type: 'text'
                                                    },
                                                    {
                                                        id: 'assigned-frequency-mhz-to-tx',
                                                        header: 'Assigned Frequency (MHz) - To (Tx)',
                                                        type: 'text'
                                                    },
                                                    {
                                                        id: 'assigned-frequency-mhz-from-rx',
                                                        header: 'Assigned Frequency (MHz) - From (Rx)',
                                                        type: 'text'
                                                    },
                                                    {
                                                        id: 'assigned-frequency-mhz-to-rx',
                                                        header: 'Assigned Frequency(MHz) - To (Rx)',
                                                        type: 'text'
                                                    },
                                                    {
                                                        id: 'assigned-bandwidth-khz-tx',
                                                        header: 'Assigned Bandwidth (kHz) (Tx)',
                                                        type: 'text'
                                                    },
                                                    {
                                                        id: 'assigned-bandwidth-khz-rx',
                                                        header: 'Assigned Bandwidth (kHz) (Rx)',
                                                        type: 'text'
                                                    },
                                                    {
                                                        id: 'emission-class-tx',
                                                        header: 'Emission Class (Tx)',
                                                        type: 'text'
                                                    },
                                                    {
                                                        id: 'emission-class-rx',
                                                        header: 'Emission Class (Rx)',
                                                        type: 'text'
                                                    }
                                                ]
                                            },
                                            {
                                                id: 'mobile-station-frequency-info-accordion',
                                                label: '',
                                                type: 'accordion',
                                                subFields: [
                                                    {
                                                        id: 'assigned-transmit-frequency-details',
                                                        label: 'Assigned Transmit Frequency details',
                                                        type: 'text'
                                                    },
                                                    {
                                                        id: '',
                                                        label: '',
                                                        type: 'text'
                                                    },
                                                    {
                                                        id: 'frequency-entry-tx',
                                                        label: 'Frequency Entry',
                                                        type: 'text'
                                                    },
                                                    {
                                                        id: '',
                                                        label: '',
                                                        type: 'text'
                                                    },
                                                    {
                                                        id: 'power',
                                                        label: 'Power (≤)',
                                                        type: 'text'
                                                    },
                                                    {
                                                        id: 'power-unit',
                                                        label: 'Power Unit',
                                                        type: 'text'
                                                    },
                                                    {
                                                        id: 'assigned-transmit-frequency-details',
                                                        label: 'Assigned Transmit Frequency details',
                                                        type: 'text'
                                                    },
                                                    {
                                                        id: '',
                                                        label: '',
                                                        type: 'text'
                                                    },
                                                    {
                                                        id: 'frequency-entry-rx',
                                                        label: 'Frequency Entry',
                                                        type: 'text'
                                                    }
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                ]
            }
        ]
    },
    {
        sectionID: SUPPORTING_DOCUMENTS,
        sectionName: 'Supporting Documents',
        fieldList: [
            {
                id: 'supporting-documents',
                label: ' ',
                type: 'file',
                span: 12
            }
        ]
    }
];
